export type TSubModal = {
  id?: string;
  props?: Record<string, any>;
  component: string;
};

export class ModalState {
  constructor(public submodals: TSubModal[]) {}
}
